//所有的常量配置

/**
 * @module config 项目中全局的配置
 * 
 * @baseUrl   请求的域名
 * @timeout   超时时间
*/
export default {
    baseUrl: 'https://sc1.zzhxyy.com',
    timeout: 8000,
}